/*
    El layout activo es 'horizontal' (ver themeConfig.js), así que este menú
    solo se usa en pantallas menores a xl, donde el horizontal se colapsa.
    Aun así debe reflejar lo mismo que `navigation/horizontal/`: mismo orden,
    mismos iconos y los mismos módulos.
*/
export default [{
        title: 'Inicio',
        route: 'home',
        icon: 'HomeIcon'
    },
    {
        title: 'Anuncios',
        icon: 'BellIcon',
        children: [{
            title: 'Lista',
            route: 'notices'
        }, {
            title: 'Agregar',
            route: 'notices-create'
        }]
    },
    {
        title: 'Doctores',
        icon: 'ActivityIcon',
        children: [{
            title: 'Lista',
            route: 'doctors'
        }, {
            title: 'Agregar',
            route: 'doctors-create'
        }]
    },
    {
        title: 'Reservas',
        icon: 'CheckCircleIcon',
        children: [{
            title: 'Lista',
            route: 'bookings'
        }, {
            title: 'Agregar',
            route: 'booking-create'
        }, {
            title: 'Calendario',
            route: 'bookings-calendar'
        }]
    },
    {
        title: 'Encuestas',
        icon: 'MessageSquareIcon',
        children: [{
            title: 'Lista',
            route: 'surveys'
        }]
    },
    {
        title: 'Testimonios',
        icon: 'StarIcon',
        children: [{
            title: 'Lista',
            route: 'testimonials'
        }]
    },
    {
        title: 'Noticias',
        icon: 'GlobeIcon',
        children: [{
            title: 'Lista',
            route: 'news'
        }, {
            title: 'Agregar',
            route: 'news-create'
        }]
    },
    {
        title: 'Blog',
        icon: 'LayoutIcon',
        children: [{
            title: 'Lista',
            route: 'blogs'
        }, {
            title: 'Agregar',
            route: 'blogs-create'
        }]
    },
    {
        title: 'Cupones de descuento',
        icon: 'PaperclipIcon',
        children: [{
            title: 'Lista',
            route: 'coupons'
        }, {
            title: 'Agregar',
            route: 'coupons-create'
        }]
    }
]
